import { Button, Component, Node, _decorator } from 'cc';
import MultiThemeSource from '../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSource';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import ValueToggleSelector from '../../../../common/scripts/Toolkit/Components/ValuePicker/ValueToggleSelector';
import ValueSelector from '../../../../common/scripts/Toolkit/Helper/ValueSelector';
import { PlayType } from '../../../../tableEngine/Script/Game/Data/Model/TableModel';
import Lobby from '../../../System/Lobby';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('LobbyGameRulePage')
@requireComponent(Page)
export default class LobbyGameRulePage extends Component {
    @property(ValueToggleSelector)
    protected readonly tabSelector: ValueToggleSelector = null;

    @property(MultiThemeSource)
    protected readonly contentMultiThemeSource: MultiThemeSource = null;

    private _page: Page = null;
    private _tabValueSelector: ValueSelector<number> = null;

    private get page(): Page {
        if (!this._page) {
            this._page = this.node.getComponent(Page);
        }
        return this._page;
    }

    public onLoad() {
        this._tabValueSelector = new ValueSelector(Lobby.config.supportedPlayType.map((playType) => +PlayType.map(playType)));
        this.tabSelector.init(
            this._tabValueSelector,
            () => {},
            (option: Node, isSelected: boolean) => {
                option.getComponent(Button).keep = isSelected;
            },
        );
        this._tabValueSelector.on(ValueSelector.EVENT_TYPE.VALUE_CHANGED, this._onSelectedTabChanged, this);

        this.page.once(Page.EVENT_TYPE.OPEN_START, () => {
            this._tabValueSelector.currentIdx = PlayType.map(Lobby.hall.currentPlayType);
        });

        this.page.on(Page.EVENT_TYPE.OPEN_START, () => {});
    }

    private _onSelectedTabChanged() {
        this.contentMultiThemeSource.theme = this._tabValueSelector.value;
    }
}
